import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function BlogArticle() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [relatedArticles, setRelatedArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticle();
    window.scrollTo(0, 0);
  }, [slug]);

  const fetchArticle = async () => {
    try {
      const response = await axios.get(`${API}/articles/${slug}`);
      setArticle(response.data);
      fetchRelatedArticles(response.data.category);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching article:', error);
      setLoading(false);
    }
  };

  const fetchRelatedArticles = async (category) => {
    try {
      const response = await axios.get(`${API}/articles?category=${encodeURIComponent(category)}`);
      const filtered = response.data.filter(a => a.slug !== slug).slice(0, 3);
      setRelatedArticles(filtered);
    } catch (error) {
      console.error('Error fetching related articles:', error);
    }
  };

  if (loading) {
    return (
      <div className="app">
        <div className="loading-container">
          <p>Chargement de l'article...</p>
        </div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="app">
        <div className="error-container">
          <h2>😕 Article non trouvé</h2>
          <button onClick={() => navigate('/blog')} className="btn btn-primary">
            Retour au blog
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
            <span className="logo-text">AmsWeb</span>
            <span className="logo-subtitle">Aide MultiServices du Web</span>
          </div>
          <div className="nav-links">
            <a href="/" className="nav-link">Accueil</a>
            <a href="/formations-outils" className="nav-link">Formations</a>
            <a href="/blog" className="nav-link">Blog</a>
            <a href="/#contact" className="nav-link nav-cta">Contact</a>
          </div>
        </div>
      </nav>

      <article className="article-page">
        <div className="article-header">
          <div className="container-article">
            <button onClick={() => navigate('/blog')} className="back-button">
              ← Retour au blog
            </button>
            <div className="article-category-badge">{article.category}</div>
            <h1 className="article-title">{article.title}</h1>
            <div className="article-meta">
              <span>📅 {new Date(article.created_at).toLocaleDateString('fr-FR')}</span>
              <span>👤 Fred d'AmsWeb</span>
            </div>
          </div>
        </div>

        <div className="article-image-container">
          <img src={article.image_url} alt={article.title} className="article-main-image" />
        </div>

        <div className="article-content-section">
          <div className="container-article">
            <div className="article-layout">
              <div className="article-main">
                <div 
                  className="article-content" 
                  dangerouslySetInnerHTML={{__html: article.content || article.excerpt}}
                />

                <div className="article-cta-box">
                  <h3>🚀 Tu veux aller plus loin ?</h3>
                  <p>Découvre nos formations pour développer ton activité MLM</p>
                  <button
                    onClick={() => navigate('/formations-outils')}
                    className="btn btn-primary"
                  >
                    Voir les Formations
                  </button>
                </div>
              </div>

              <aside className="article-sidebar">
                <div className="sidebar-box">
                  <h3>📬 Reste Informé</h3>
                  <p>Reçois les derniers articles et astuces MLM directement dans ta boîte mail</p>
                  <button
                    onClick={() => navigate('/#contact')}
                    className="btn btn-primary btn-small"
                  >
                    S'inscrire
                  </button>
                </div>

                {relatedArticles.length > 0 && (
                  <div className="sidebar-box">
                    <h3>📚 Articles Similaires</h3>
                    <div className="related-articles">
                      {relatedArticles.map((related) => (
                        <div
                          key={related.id}
                          className="related-article-item"
                          onClick={() => navigate(`/blog/${related.slug}`)}
                        >
                          <img src={related.image_url} alt={related.title} />
                          <h4>{related.title}</h4>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </aside>
            </div>
          </div>
        </div>
      </article>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>AmsWeb</h3>
              <p>Aide MultiServices du Web</p>
            </div>
            <div className="footer-section">
              <h4>Navigation</h4>
              <ul className="footer-links">
                <li><a href="/">Accueil</a></li>
                <li><a href="/formations-outils">Formations</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>✉️ <a href="mailto:contact@amsweb.fr">contact@amsweb.fr</a></p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 AmsWeb.fr - Tous droits réservés</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default BlogArticle;
